<template>
  <div class="subscription-list-empty">
    <div class="layout-background">
      <subscription-empty-list-animation />
    </div>
    <div class="title">
      {{ $t('try.subscription.service') }}
    </div>
    <div class="text-medium">
      <p>
        {{ $t('need.regular.audience.support') }}
      </p>
      <p>
        {{ $t('course.lasts.several.months') }}
      </p>
      <p>
        {{ $t('can.use.private.chat.only.for.fee') }}
      </p>
    </div>
    <div class="button-container">
      <a class="button thin action" @click="onRouteSubscription">
        <span>{{ $t('create.bill.subscription') }}</span>
      </a>
    </div>
    <div class="text-small" v-html="$t('show.subscribers.list.after.first.successful.payment')"></div>
  </div>
</template>

<script>
import SubscriptionEmptyListAnimation from '@/resources/tilda/SubscriptionEmptyListAnimation';

import { INVOICING } from '@/router/const';

export default {
  name: 'SubscriptionEmptyList',
  components: {
    SubscriptionEmptyListAnimation,
  },
  methods: {
    onRouteSubscription() {
      this.$router.push({ name: INVOICING, hash: '#subscription' });
    },
  },
};
</script>

<style lang="sass" scoped>
  .layout-background
    width: 100%
    height: 100%
    overflow: hidden
    position: absolute
    top: 0
    left: 0
    z-index: -1

  .subscription-list-empty
    width: 100%
    max-width: 620px
    margin: 0 auto
    padding: 325px 0 40px
    display: flex
    flex-direction: column
    align-items: center

    +respond-to("medium")
      padding: 77px 0 83px

  .title
    display: flex
    margin-bottom: 33px
    text-align: center
    font-size: 30px
    line-height: 36px
    font-weight: 600

    +respond-to("medium")
      font-size: 64px
      line-height: 82px
      margin-bottom: 38px

  .text-medium
    width: 100%
    max-width: 290px
    margin-bottom: 30px
    padding: 0 20px
    display: flex
    flex-direction: column
    justify-content: space-between
    text-align: center
    font-size: 20px
    font-weight: 300
    line-height: 28px
    box-sizing: border-box

    +respond-to("medium")
      margin-bottom: 35px
      padding: 0
      line-height: 24px

    p
      &:not(:last-child)
        margin-bottom: 26px

  .text-small
    width: 100%
    max-width: 360px
    padding: 0 20px
    font-size: 16px
    font-weight: 400
    line-height: 22px
    text-align: center
    color: #fff
    opacity: 0.7
    box-sizing: border-box

    span
      display: inline

    +respond-to("medium")
      padding: 0
      font-size: 16px
      line-height: 22px

      span
        display: inline-block

  .button-container
    width: 100%
    max-width: 376px
    height: 65px
    margin-bottom: 35px
    padding: 0 10px
    box-sizing: border-box

    +respond-to("medium")
      height: 70px
      padding: 0

    & .button.action
      height: 100%
      padding: 0
      font-size: 20px
      font-weight: 600
      line-height: 28px

      +respond-to("medium")
        font-size: 24px
</style>
